import { ClickableText } from '@bitstopco/bitstop-theme';
import type { ClickableTextProps } from '@bitstopco/bitstop-theme';

export interface TableHashActionProps extends ClickableTextProps {
  to: string;
  url?: string;
}

const TableColumnExplorer = ({ to, url = '', ...props }: TableHashActionProps) => (
  <ClickableText
    {...props}
    to={url.replace('{txhash}', to)}
    overrideTooltipLinkText="Go to Explorer"
  />
);

export default TableColumnExplorer;
